import gql from "graphql-tag";

const ActivityProps = gql`
	fragment ActivityProps on PatientActivity {
		id
		created_at
		datetime
		taken {
			status
			observation
		}
		category {
			id
			name
			image
		}
	}
`;

const LIST = gql`
	query GetPatientActivityList($id: ID!, $site: ID!) {
		GetPatientActivities(admission: $id) {
			docs {
				...ActivityProps
			}
		}
		GetNoteCategories(site: $site) {
			docs {
				id
				name
				image
			}
		}
	}
	${ActivityProps}
`;

const CREATE = gql`
	mutation NewPatientActivity($model: ActivityInput!) {
		NewPatientActivity(model: $model) {
			message
			doc {
				...ActivityProps
			}
		}
	}
	${ActivityProps}
`;

const SET_TAKEN = gql`
	mutation SetTaken($id: ID!, $observation: String) {
		SetActivityTaken(id: $id, observation: $observation) {
			message
			doc {
				...ActivityProps
			}
		}
	}
	${ActivityProps}
`;
const COMPLETED_ACTIVITIES = gql`
	query GetCompletedActivities($admission: ID!, $page: Int, $limit: Int) {
		GetCompletedPatientActivities(
			admission: $admission
			page: $page
			limit: $limit
		) {
			docs {
				...ActivityProps
				author {
					id
					surname
					first_name
					middle_name
					email
					type {
						id
						name
					}
					designation {
						id
						name
					}
					image
				}
			}
			page
			limit
			totalDocs
			totalPages
			prevPage
			nextPage
		}
	}
	${ActivityProps}
`;
export { LIST, CREATE, SET_TAKEN, COMPLETED_ACTIVITIES };
